module.exports = __webpack_public_path__ + "img/DE00402.274b4eb5.png";